module.exports = __webpack_public_path__ + "static/media/maintenance.531ead8b.png";